export const FAMILY_SALE_TAGS = [
  'zz_cee_familyweek',
  'zz_DE_Familie',
  'zz_DK_Family',
  'zz_family',
  'zz_familyfriendly',
  'zz_family_SWE',
  'zz_hu_family',
  'zz_IT_family',
  'zz_promotion_family_583',
  'zz_promotion_nlbe_family_friendly_418',
  'zz_promotion_no_familyfriendly_519',
  'zz_promotion_special_famille_602',
  'zz_promotion_us_family_friendly_408',
  'ds_family-travel',
  'family',
];
